import { motion } from "framer-motion";
import { Nav } from "@/components/Nav";
import { FeatureBlock } from "@/components/FeatureBlock";
import { Benefits } from "@/components/Benefits";
import { Footer } from "@/components/Footer";

const EASE = [0.16, 1, 0.3, 1];

const AI_POINTS = [
  "Watches for early warning signs during every checkup",
  "Writes a clean summary so the doctor sees what matters first",
  "Connects you to a live doctor the moment something looks off",
  "Gets smarter with every visit — your data stays private and locked",
];

export default function Ai() {
  return (
    <main data-testid="ai-page">
      <Nav />

      <section className="pt-36 sm:pt-44 pb-20 px-6 sm:px-12 max-w-3xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.3 }}
          className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#808080]"
        >
          AI
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.4 }}
          className="font-display font-semibold tracking-tight text-[#3A3A3C] text-4xl sm:text-5xl mt-4 leading-[1.1]"
          data-testid="ai-title"
        >
          The brain inside the Hub.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.55 }}
          className="text-base text-[#474747] leading-relaxed mt-6"
        >
          Every Hub runs on AI that watches, learns and looks out for you — and knows exactly when to
          bring in a real human doctor.
        </motion.p>
      </section>

      <div className="space-y-3">
        <FeatureBlock
          poster="/media/feature-triage.png"
          eyebrow="01 — Smart Eyes"
          title="The AI looks out for you."
          copy="Smart cameras spot early warning signs before a nurse even walks in."
          testid="feature-triage"
        />
        <FeatureBlock
          poster="/media/telehealth.png"
          eyebrow="02 — Video Doctor"
          title="Talk to a real doctor, face to face."
          copy="A live doctor joins on screen, looks at your results and can diagnose you on the spot — no weeks of waiting."
          testid="feature-telehealth"
        />
      </div>

      <Benefits title="What the AI does for you." items={AI_POINTS} testid="ai-benefits" />

      <Footer />
    </main>
  );
}
